import type { CalendarDate } from "@internationalized/date";

export type ValidityRange = {
  start: CalendarDate;
  end: CalendarDate;
} | null;

const formatCalendarDate = (date: CalendarDate, locale: string): string =>
  new Date(date.year, date.month - 1, date.day).toLocaleDateString(locale);

export function getValidFromLabel(
  range: ValidityRange,
  locale: string,
): string | null {
  if (!range) return null;
  return `${formatCalendarDate(range.start, locale)} 00:00`;
}

export function getValidToLabel(
  range: ValidityRange,
  locale: string,
): string | null {
  if (!range) return null;
  return `${formatCalendarDate(range.end, locale)} 23:59`;
}
